//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { popOverFactory } from 'common/components/core/popover/popOverFactory';
import ReactTelInputComponent from 'react-telephone-input/lib/withStyles';
import theme from './ReactTelInput.scss';

type Props = {
    className?: string,
    error?: ?string,
    value?: string,
    flagsImagePath?: string,
    preferredCountries: Array<string>,
    defaultCountryISOCode: string,
    theme: Object,
    onChange: (value: string, selectedCountry: Object) => void
};

export const ReactTelInputWithPopOver = popOverFactory({
    Component: ReactTelInputComponent,
    withObserverFlag: true
});

class ReactTelInput extends React.PureComponent<Props> {
    static defaultProps = {
        autoFormat: false,
        flagsImagePath: '/img/flags.png',
        defaultCountryISOCode: 'in',
        preferredCountries: ['in', 'us']
    };

    onChange = (value, selectedCountry) => {
        const { onChange } = this.props;
        if (value === '+') {
            /* This is done to avoid sending invalid data ('+') on change.
             * The component handles this internally by showing a '+' always
             */
            onChange('', selectedCountry);
            return;
        }
        onChange && onChange(value, selectedCountry);
    };

    render() {
        const {
            className,
            theme,
            error,
            flagsImagePath,
            preferredCountries,
            value,
            defaultCountryISOCode,
            ...others
        } = this.props;
        return (
            <ReactTelInputWithPopOver
                {...others}
                defaultCountry={defaultCountryISOCode}
                classNames={classnames(theme.phoneInput, theme.intl, {
                    [className]: !!className
                })}
                inputProps={{
                    className: theme.input
                }}
                autoFormat={false}
                value={value}
                preferredCountries={preferredCountries}
                flagsImagePath={flagsImagePath}
                onChange={this.onChange}
                isPopOverOpen={!!error}
                popOverContent={error}
            />
        );
    }
}

const ThemedReactTelInput = themr(null, theme)(ReactTelInput);

export { ThemedReactTelInput as ReactTelInput };
export default ThemedReactTelInput;
